import React from 'react';
import _ from 'lodash';
import Joi from 'joi-browser';
import Helmet from 'react-helmet';

import EventMg, { EventType } from '../utilities/EventManager';
import dialogLoader from '../utilities/dialogLoader';
import { messageUtility } from '../utilities/messageUtility';
import Information from '../components/modals/common/Information';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import regex from '../utilities/validateRegex';
import { validateByJoi } from '../utilities/validation';
import LocalStorageService from '../services/utilities/LocalStorageService';
import {
  USER_ROLES,
  REQUEST_PARAMS, // API LIMIT
  HEADER_CONSTANTS, // ヘッダータイトル
  INTEGRATE_USER_COMMON_ERROR_MESSAGE,
  INTEGRATE_USER_SUCCESS_TITLE,
  INTEGRATE_USER_SUCCESS_MESSAGE,
} from '../utilities/constants';
import { CompanyBranchService } from '../services/CompanyBranches'; // 協力会社API
import {
  csvDownloader,
  getOneMasterTypeNameCompanyNumber,
} from '../utilities/commonUtil';
import {
  PartnerUserTableHeadings,
  PartnerUserTableContents,
} from '../components/tables/PartnerUsers'; // テーブ表示部分
import { PartnerUsersSearchForm } from '../components/searchmenus/PartnerUsers'; // 検索フォーム
import PrimeContractorButton from '../../src/components/button/PrimeContractorButton';
import ForemanNewPasswordDialog, {
  DialogType,
} from '../../src/components/dialogs/ForemanNewPasswordDialog';
import { deleteControlCode } from '../utilities/stringUtil';
import { MasterPageHeader } from '../components/PageHeader';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { HEAD_OFFICE_OPTION } from '../components/PartnerCompanyBranchDropdown';
import { ConfirmIntegrateUserDialog } from '../components/modals/ConfirmIntegrateUserDialog';
import { LoginUserGroupsService } from '../services/LoginUserGroups';
import { ConfirmExistedEmailDialog } from '../components/modals/ConfirmExistedEmailDialog';
import { IntegrateError } from '../components/modals/IntegrateError';
import EventManager from '../utilities/EventManager';
import { BuildeeManagerIcon } from '../components/icons/BuildeeManagerIcon';
import { CompanyService } from '../services/Companies';
import RegisteredCompaniesDialog from '../components/modals/RegisteredCompaniesDialog';
import PartnerUsersEventMg, {
  PARTNER_USERS_EVENTS,
} from '../components/PartnerUsersEvents';
import * as fieldTreeDialog from '../components/FieldTreeDialog';
import { Description } from '../components/Description';
import {
  FormList,
  FormListItem,
  FormElement,
} from '../components/CommonFormComponents';

const MY_EVENT = {
  LOAD_PARTNER_USERS: 'load_partner_users', // 一覧取得
};
const INIT_SEARCH_CONDITIONS = {
  fullname: '', // 名前
  user_role_code: '', // 種別
  partner_company_branch_id: null,
};

/**
 * @description 協力会社ユーザー確認画面
 * 画面遷移協力会社一覧
 * 協力会社一覧 > リスト内の ユーザー確認
 */
export class PartnerUsers extends React.Component {
  constructor(props) {
    super(props);

    // パラメータ分解
    const param = this.props.view.state.id.split('.');

    this.state = {
      isOpened: false, // 検索フォーム開閉フラグ
      isLoading: true, // ロード中フラグ
      loaded: false, // 全件取得済みフラグ
      total: 0, // 総数
      adminFindFlag: false, // 協力会社管理者がいるかフラグ
      partnerCompanyId: param[0], // 協力会社ID
      companyBranchId: param[1], // 支店ID
      company: {
        name: '',
      }, // 協力会社情報
      partnerUsers: [], // 協力会社ユーザー一覧
      openDialog: false, // 招待ダイアログ開閉状態
      searchConditions: INIT_SEARCH_CONDITIONS, // 検索条件
      csvSearchConditions: INIT_SEARCH_CONDITIONS, // 検索条件(CSV用)
      invitePartner: {
        company_id: param[0], // 協力会社ID
        company_branch_id: param[1], // 支店ID
        name_sei: '', // 姓
        name_mei: '', // 名
        kana_sei: '', // せい
        kana_mei: '', // めい
        email: '', // メールアドレス
        errors: {}, // バリデーションメッセージ
        validated: false, // バリデーションフラグ
        readOnly: false,
      },
      showSendConfirmDialog: false,
      partnerCompanyBranchId: null,
      isShowPopupConfirmIntegrateUser: false,
      isShowPopupExistedEmail: false,
      isShowPopupIntegrateUserError: false,
      isIntegrateSuccess: false,
      isShowPopupInfo: false,
      userIntegrates: [],
      checkIntegrateError: false,
      messageIntegrate: '',
      registeredCompanies: [],
      isShowRegisteredCompaniesDialog: false,
      popupInfoTitle: '',
      popupInfoMessage: '',
    };
    this.isSubmittingFlag = false;
    this.searchingFlag = false;
    this.isDownloadingFlag = false;

    // バリデーションパターン
    this.schema = Joi.object().keys({
      company_id: Joi.number(), // 会社ID
      company_branch_id: Joi.number(), // 支店ID
      name_sei: Joi.string()
        .required()
        .max(64), // 姓
      name_mei: Joi.string()
        .required()
        .max(64), // 名
      kana_sei: Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .required()
        .max(128), // せい
      kana_mei: Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .required()
        .max(128), // めい
      email: Joi.string()
        .label('email')
        .regex(regex.pattern.email)
        .max(255)
        .required(), // メールアドレス
    });

    // ユニークID生成
    this.id = _.uniqueId();
    this.joiningFlag = SessionStorageService.getPartnerCompanyJoiningFlag();

    this.events = {
      dialog: {
        // ダイアログ
        invite: this.handleInviteDialog, // 閉じる
      },
      search: {
        handleOpen: this.handleFormOpen, // 検索フォーム開閉イベント
        set: this.setCondition, // 検索条件セット
        execution: this.searchExecution, // 検索実行
        clear: this.clearConditions, // 検索条件クリア
      },
      table: {
        edit: this.editRow, // 編集画面へ遷移
      },
      output: this.csvDownloadPreparation, // CSV出力
    };

    // 管理者招待ダイアログ
    this.Invite = {
      callback: {
        submit: this.submitInvitePartner,
        set: this.setInvitePartnerData,
        check: this.isAvailable,
        close: () => {
          this.events.dialog.invite(false);
        },
        cancel: this.closeConfirmationDialog,
        confirm: this.onSubmitConfirmationDialog,
      },
    };

    this.searchButtonRef = React.createRef(); // 検索ボタン要素

    // 一覧取得イベント登録
    EventMg.registerEvent(MY_EVENT.LOAD_PARTNER_USERS);
    EventMg.addEventListener(MY_EVENT.LOAD_PARTNER_USERS, () => {});

    //新規作成誤登録防止ダイアログ
    EventMg.addEventListener(PARTNER_USERS_EVENTS.NEW_PRE_DIALOG, () => {
      dialogLoader.show(fieldTreeDialog.PartnerUserNewPreDialog, {
        callback: {
          new: () => {
            dialogLoader.close();
            EventMg.trigger(PARTNER_USERS_EVENTS.NEW_DIALOG);
          },
          back: () => {
            dialogLoader.close();
          },
        },
        state: {
          companyName: this.state.company.name,
          companyAddress:
            (this.state.company.prefecture_name || '') +
            (this.state.company.city_name || '') +
            (this.state.company.street_number || '') +
            (this.state.company.building_name || ''),
          oneMasterTypeNameCompanyNumber: getOneMasterTypeNameCompanyNumber(
            this.state.company.one_master_flag,
            this.state.company.company_number
          ),
        },
      });
    });

    //新規作成ダイアログ
    EventMg.addEventListener(PARTNER_USERS_EVENTS.NEW_DIALOG, () => {
      dialogLoader.show(fieldTreeDialog.PartnerUserNewDialog, {
        callback: {
          invite: () => {
            dialogLoader.close();
            this.events.dialog.invite(true);
          },
          // 職長新規登録のボタン
          new: () => {
            dialogLoader.close();
            const id = `${this.state.partnerCompanyId}.${
              this.state.companyBranchId
            }`;
            _masterSlideLoader.show('ForemanRegister', {
              state: { id },
            });
          },
          back: () => {
            dialogLoader.close();
          },
        },
        state: {
          companyName: this.state.company.name,
        },
      });
    });
  }

  componentDidMount() {
    const invitePartner = _.cloneDeep(this.state.invitePartner);
    const { companyBranchId, partnerCompanyId } = this.state;
    const param = { company_branch_id: companyBranchId };

    // 協力会社情報取得
    CompanyBranchService.show(partnerCompanyId, param).then(
      ({ result, data }) => {
        if (result) {
          const { company, company_branch } = data.entities;
          invitePartner.companyName = company.name;
          invitePartner.companyAddress =
            (company.prefecture_name || '') +
            (company.city_name || '') +
            (company.street_number || '') +
            (company.building_name || '');

          this.setState({ company, company_branch, invitePartner });
          this.getPartnerUsers();
        }
      }
    );
  }

  componentWillUnmount() {
    // イベント削除
    EventMg.deleteEvent(MY_EVENT.LOAD_PARTNER_USERS);
    PartnerUsersEventMg.removeAll();
  }

  /**
   * 検索フォーム開閉
   */
  handleFormOpen = () => {
    this.setState({ isOpened: !this.state.isOpened });
  };

  /**
   * 管理者招待ダイアログ表示
   * @param open {bool}
   */
  handleInviteDialog = open => {
    if (open) {
      dialogLoader.show(InviteDialog, this.Invite, this.state.invitePartner);
    } else {
      let invitePartner = { ...this.state.invitePartner };
      invitePartner.company_name = '';
      invitePartner.name_sei = '';
      invitePartner.name_mei = '';
      invitePartner.kana_sei = '';
      invitePartner.kana_mei = '';
      invitePartner.email = '';
      invitePartner.errors = {};
      invitePartner.validated = false;
      invitePartner.readOnly = false;
      this.setState({ invitePartner });
      dialogLoader.close();
    }

    this.setState({ openDialog: open });
  };

  /**
   * 招待する管理者情報をセット
   */
  setInvitePartnerData = e => {
    let invitePartner = this.state.invitePartner;
    invitePartner[e.target.name] = deleteControlCode(e.target.value);
    this.setState({ invitePartner });
    dialogLoader.redraw(InviteDialog, this.Invite, invitePartner);

    // if (this.state.invitePartner.validated) {
    //   this.isAvailable(invitePartner);
    // }
  };

  /**
   * 入力値の有効判定
   * @return bool
   */
  isAvailable = e => {
    let invitePartner = { ...this.state.invitePartner };
    const values = {
      company_id: invitePartner.company_id, // 協力会社ID
      company_branch_id: invitePartner.company_branch_id, // 支店ID
      name_sei: invitePartner.name_sei, // 姓
      name_mei: invitePartner.name_mei, // 名
      kana_sei: invitePartner.kana_sei, // せい
      kana_mei: invitePartner.kana_mei, // めい
      email: invitePartner.email, // メールアドレス
    };

    const validated = validateByJoi(this.schema, values);
    const available = validated.result;

    // エラーメッセージをセット
    if (!_.isEmpty(e)) {
      const name = e.target.name;
      if (_.has(validated.messages, name)) {
        invitePartner.errors[name] = validated.messages[name];
      } else if (invitePartner.errors[name]) {
        delete invitePartner.errors[name];
      }
    } else {
      // 送信ボタン押下時
      if (!available) {
        _.each(validated.messages, (message, key) => {
          invitePartner.errors[key] = message;
        });
      }
    }

    invitePartner.errors.submit = '';
    this.setState({ invitePartner });
    if (!this.state.showSendConfirmDialog) {
      dialogLoader.redraw(InviteDialog, this.Invite, invitePartner);
    }
    return available;
  };

  /**
   * 管理者招待 ダイアログの「送信」押下後のAPI呼び出し
   */
  // eslint-disable-next-line no-unused-vars
  invitePartner = () => {
    this.setState({ isShowPopupExistedEmail: false });
    if (this.isAvailable()) {
      // InviteDialogでisAvailableをうまく制御できなかったため親Componentで分岐
      if (!this.state.showSendConfirmDialog) {
        const invitePartner = _.cloneDeep(this.state.invitePartner);
        invitePartner.readOnly = true;
        return this.setState(
          {
            showSendConfirmDialog: true,
            invitePartner,
          },
          () => {
            dialogLoader.redraw(InviteDialog, this.Invite, invitePartner);
          }
        );
      }
      if (this.isSubmittingFlag) {
        return;
      }
      this.isSubmittingFlag = true;
      // event.target.disabled = true;
      const param = {
        company_id: this.state.invitePartner.company_id, // 協力会社ID
        company_branch_id: this.state.invitePartner.company_branch_id, // 支店ID
        name_sei: this.state.invitePartner.name_sei, // 姓
        name_mei: this.state.invitePartner.name_mei, // 名
        kana_sei: this.state.invitePartner.kana_sei, // せい
        kana_mei: this.state.invitePartner.kana_mei, // めい
        email: this.state.invitePartner.email, // メールアドレス
      };

      // 協力会社管理者招待
      CompanyBranchService.partnerUser(param)
        .then(response => {
          let invitePartner = { ...this.state.invitePartner };
          if (response.result) {
            invitePartner.company_name = '';
            invitePartner.name_sei = '';
            invitePartner.name_mei = '';
            invitePartner.kana_sei = '';
            invitePartner.kana_mei = '';
            invitePartner.email = '';
            invitePartner.errors = {};
            invitePartner.validated = false;
            invitePartner.readOnly = false;
            this.setState({ invitePartner, showSendConfirmDialog: false });
            this.invitePartnerConfirmDialog();
          } else {
            // エラー時のハンドリング
            // event.target.disabled = false;
            const invitePartner = _.cloneDeep(this.state.invitePartner);
            invitePartner.readOnly = false;
            // エラーメッセージを入れる
            invitePartner.errors.submit = response.data.message;
            this.setState(
              {
                invitePartner,
                showSendConfirmDialog: false,
              },
              () => {
                dialogLoader.redraw(InviteDialog, this.Invite, invitePartner);
              }
            );
          }
        })
        .finally(() => {
          this.isSubmittingFlag = false;
        });
    }
  };

  /**
   * 招待メール送信確認ダイアログ表示
   * @param PartnerUser {object}
   */
  invitePartnerConfirmDialog = () => {
    dialogLoader.show(fieldTreeDialog.InviteSuccess, {
      callback: {
        done: () => {
          dialogLoader.close();
          this.setState(
            {
              loaded: false,
              partnerUsers: [],
              isLoading: true,
            },
            this.getPartnerUsers
          );
        },
      },
    });
  };

  /**
   * 詳細画面へ遷移
   * @param PartnerUser {object}
   */
  editRow = PartnerUser => {
    // 協力会社ID.支店ID
    const param = {
      state: {
        id: `${this.state.partnerCompanyId}.${this.state.companyBranchId}.${
          PartnerUser.id
        }`,
      },
    };
    _masterSlideLoader.show('PartnerUserPreview', param);
  };

  /**
   * @description 検索条件クリア
   */
  clearConditions = async () => {
    if (this.searchingFlag) {
      return;
    }
    this.searchingFlag = true;
    this.setState(
      {
        loaded: false,
        partnerUsers: [],
        searchConditions: INIT_SEARCH_CONDITIONS,
        csvSearchConditions: INIT_SEARCH_CONDITIONS,
        isLoading: true,
        partnerCompanyBranchId: null,
      },
      this.getPartnerUsers
    );
  };

  /**
   * @description 検索条件設定
   * @param {*} event
   */
  setCondition = event => {
    const { name, value } = event.target;
    const { searchConditions } = this.state;

    this.setState({
      searchConditions: {
        ...searchConditions,
        [name]: value,
      },
    });
  };

  /**
   * @description 検索実行
   */
  searchExecution = () => {
    if (this.searchingFlag) {
      return;
    }
    this.searchingFlag = true;
    if (this.searchButtonRef.current) {
      this.searchButtonRef.current.disabled = true;
    }

    this.setState(
      {
        loaded: false,
        partnerUsers: [],
        isLoading: true,
        csvSearchConditions: this.state.searchConditions,
      },
      this.getPartnerUsers
    );
  };

  /**
   * 一覧取得
   */
  getPartnerUsers = (notify = () => {}, forceExec = false) => {
    if (!forceExec && this.state.loaded) {
      notify();
      this.setState({ isLoading: false });
      this.searchingFlag = false;
      return;
    }

    const { csvSearchConditions, partnerUsers, companyBranchId } = this.state;
    const params = {
      ...csvSearchConditions,
      limit: REQUEST_PARAMS.parentLimit,
      offset: _.size(partnerUsers),
    };

    CompanyBranchService.companyPartnerUserList(companyBranchId, params)
      .then(({ data, result }) => {
        if (result) {
          const { entities, total } = data;
          const { user_lists } = entities;

          if (_.isEmpty(user_lists)) {
            this.setState({ loaded: true, total });
          } else {
            this.setState({
              partnerUsers: [...partnerUsers, ...user_lists],
              loaded: false,
              total,
            });
          }
        }
      })
      .finally(() => {
        if (this.searchButtonRef.current) {
          this.searchButtonRef.current.disabled = false;
        }
        this.searchingFlag = false;
        this.setState({ isLoading: false });
        notify();
      });
  };

  /**
   * @description CSV出力準備
   */
  csvDownloadPreparation = async () => {
    if (this.isDownloadingFlag) {
      return;
    }
    this.isDownloadingFlag = true;
    const params = _.cloneDeep(this.state.csvSearchConditions);
    const apiPath = `api/private/company_branches/${
      this.state.companyBranchId
    }/company_partner_user_list.csv`;

    await csvDownloader(apiPath, params);
    this.isDownloadingFlag = false;
  };

  handleSelectPartnerCompanyBranch = partnerCompanyBranchId => {
    const searchConditions = _.cloneDeep(this.state.searchConditions);
    if (partnerCompanyBranchId) {
      searchConditions.partner_company_branch_id =
        partnerCompanyBranchId === HEAD_OFFICE_OPTION.id
          ? ''
          : partnerCompanyBranchId;
    } else {
      delete searchConditions.partner_company_branch_id;
    }

    this.setState({
      partnerCompanyBranchId,
      searchConditions,
    });
  };

  /**
   * @description ダイアログ開閉設定
   * @param {boolean} isShow ダイアログ on/off
   */
  handleVisibleDialog = isShow => {
    this.setState({ visibleConfirmation: isShow });
  };

  closeConfirmationDialog = () => {
    const invitePartner = _.cloneDeep(this.state.invitePartner);
    invitePartner.readOnly = false;
    return this.setState(
      {
        showSendConfirmDialog: false,
        invitePartner,
      },
      () => {
        dialogLoader.redraw(InviteDialog, this.Invite, invitePartner);
      }
    );
  };

  onSubmitConfirmationDialog = () => {
    this.invitePartner();
  };

  checkIntegrateUser = async () => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    const values = this.state.invitePartner;
    const params = {
      email: values.email,
      user_role_code: USER_ROLES.partner.id,
      company_id: values.company_id,
      company_branch_id: values.company_branch_id,
    };
    const { data, result } = await LoginUserGroupsService.checkIntegrate(
      params
    );
    this.isSubmittingFlag = false;
    this.toggleDialog('isShowPopupExistedEmail', false);
    if (result) {
      return this.setState({
        userIntegrates: _.get(data, 'entities.users'),
        isShowPopupConfirmIntegrateUser: true,
      });
    }
    this.setState({
      messageIntegrate: _.get(data, 'message'),
      isShowPopupIntegrateUserError: true,
    });
  };

  handleIntegrateUser = async () => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    const invitePartner = _.cloneDeep(this.state.invitePartner);
    const formValues = {
      company_id: invitePartner.company_id,
      company_branch_id: invitePartner.company_branch_id,
      name_sei: invitePartner.name_sei,
      name_mei: invitePartner.name_mei,
      kana_sei: invitePartner.kana_sei,
      kana_mei: invitePartner.kana_mei,
      email: invitePartner.email,
    };
    const { result } = await CompanyBranchService.createPartnerUserIntegrate(
      formValues
    );
    this.isSubmittingFlag = false;
    this.toggleDialog('isShowPopupConfirmIntegrateUser', false);
    if (result) {
      this.handleInviteDialog(false);
      EventManager.trigger(EventType.REFRESH_PROFILE);
      return this.setState({
        isIntegrateSuccess: true,
        isShowPopupInfo: true,
        popupInfoTitle: INTEGRATE_USER_SUCCESS_TITLE,
        popupInfoMessage: INTEGRATE_USER_SUCCESS_MESSAGE,
      });
    }
    this.setState({
      isIntegrateSuccess: false,
      isShowPopupInfo: true,
      popupInfoTitle: messageUtility.getMessage('E-001-402'),
      popupInfoMessage: INTEGRATE_USER_COMMON_ERROR_MESSAGE,
    });
  };

  checkDuplicateEmail = async () => {
    const values = this.state.invitePartner;
    const params = {
      email: values.email,
      user_role_code: USER_ROLES.partner.id,
      company_id: values.company_id,
      company_branch_id: values.company_branch_id,
    };
    const { result } = await LoginUserGroupsService.checkDuplicateEmail(params);
    return result;
  };

  toggleDialog = (key, value) => {
    this.setState({ [key]: value }, () => {
      if (this.state.isIntegrateSuccess) {
        dialogLoader.close();
        this.getPartnerUsers(() => {}, true);
      }
    });
  };

  submitInvitePartner = () => {
    if (!this.isAvailable()) {
      return;
    }

    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    CompanyService.getRegisteredCompanies(this.state.invitePartner.company_id, {
      company_id: this.state.invitePartner.company_id,
      email: this.state.invitePartner.email,
    })
      .then(async response => {
        if (response.result) {
          const registeredCompanies = _.get(
            response,
            'data.entities.companies'
          );
          if (_.isEmpty(registeredCompanies)) {
            this.invitePartner();
          } else {
            dialogLoader.close();
            this.setState({
              isShowRegisteredCompaniesDialog: true,
              registeredCompanies,
            });
          }
        } else {
          const emailExist = await this.checkDuplicateEmail();
          if (emailExist) {
            this.toggleDialog('isShowPopupExistedEmail', true);
          } else {
            this.setState({
              isShowPopupInfo: true,
              popupInfoTitle: messageUtility.getMessage('E-001-402'),
              popupInfoMessage: _.get(response, 'data.message'),
            });
          }
        }
      })
      .finally(() => {
        this.isSubmittingFlag = false;
      });
  };

  onConfirmRegisteredCompaniesDialog = () => {
    this.toggleDialog('isShowRegisteredCompaniesDialog', false);
    this.setState(
      {
        showSendConfirmDialog: true,
      },
      () => {
        this.invitePartner();
      }
    );
  };

  onCancelRegisteredCompaniesDialog = () => {
    this.toggleDialog('isShowRegisteredCompaniesDialog', false);
    this.events.dialog.invite(false);
  };

  render() {
    const id = `${this.state.partnerCompanyId}.${this.state.companyBranchId}`;
    const roleId = LocalStorageService.getRoleId();

    /**
     * "職長の初期パスワードを再発行"のダイアログを表示
     *
     */
    const showDialog = () => {
      dialogLoader.show(ForemanNewPasswordDialog, {
        params: {
          companyBranchId: this.state.companyBranchId,
          // 自社ユーザー一覧 用
          dialogType: DialogType.USERS_LIST,
        },
        callback: {
          back: () => {
            dialogLoader.close();
          },
          submit: () => {
            dialogLoader.close();
          },
        },
      });
    };

    return (
      <div id='slide-view' className='master-slide-view show PartnerUsers'>
        <Helmet>
          <title>{`${HEADER_CONSTANTS.title} - ${
            this.state.openDialog
              ? '協力会社管理者招待'
              : '協力会社ユーザー確認'
          }`}</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader
            title={`${this.state.company.name} ユーザー確認`}
            onClose={() =>
              _masterSlideLoader.show('PartnerCompanies', { state: {} })
            }
          />
          <div id='infinityscroll-target' className='master-slide-view__table'>
            <div className='master-slide-view__menu'>
              <ul className='btn-menu'>
                <li className='btn-menu__item'>
                  <button
                    className='btn'
                    onClick={() => {
                      EventMg.trigger(PARTNER_USERS_EVENTS.NEW_PRE_DIALOG);
                    }}
                  >
                    ユーザー新規作成
                  </button>
                </li>
                <li>
                  <button
                    className='btn-text--sm'
                    onClick={() =>
                      _masterSlideLoader.show('PartnerCompanies', {
                        state: {},
                      })
                    }
                  >
                    <i className='i-back--blue i-2x vertical-middle' />
                    協力会社一覧
                  </button>
                </li>
                <li className='btn-menu__item --fx-auto sm--hidden' />
                <li className='btn-menu__item'>
                  <button
                    className='btn--sub'
                    style={
                      roleId >= USER_ROLES.partner.id
                        ? { display: 'none' }
                        : { display: 'block' }
                    }
                    onClick={this.events.output}
                  >
                    表示データをCSV出力
                  </button>
                  {/* ダイアログが出る */}
                  {/* 権限：実行できるは元請のみ（ロールで言うなら本社管理者、支店管理者、現場監督） */}
                  <PrimeContractorButton
                    buttonClass='btn--sub'
                    label={messageUtility.getMessage('I-001-004')}
                    onClick={showDialog}
                  />
                </li>
              </ul>
            </div>
            <PartnerUsersSearchForm
              selectedCompanyId={this.state.partnerCompanyId}
              total={this.state.total}
              isOpened={this.state.isOpened}
              conditions={this.state.searchConditions}
              callbacks={this.events.search}
              searchButtonRef={this.searchButtonRef}
              partnerCompanyBranchId={this.state.partnerCompanyBranchId}
              handleSelectPartnerCompanyBranch={
                this.handleSelectPartnerCompanyBranch
              }
              joiningFlag={this.joiningFlag}
            />
            {/* 警告メッセージ */}
            <Information
              visible={this.state.visibleConfirmation}
              message={messageUtility.getMessage('E-001-102')}
              buttonText={messageUtility.getMessage('I-000-008')}
              onClose={() => this.handleVisibleDialog(false)}
              buttonClassName='btn--sm--sub'
            />
            <div className={'PartnerUsers__notice'}>
              サービス権限の変更は、所属会社の企業管理者のみが行えます。企業管理者は種別欄に{' '}
              <BuildeeManagerIcon
                className={`icon--2x `}
                style={{ verticalAlign: 'top' }}
              />
              が表示されます。
            </div>
            <div className='master-slide-view__body'>
              <div className='constructionlist__list'>
                <table className='table table--constructionlist__list'>
                  <PartnerUserTableHeadings joiningFlag={this.joiningFlag} />
                  <PartnerUserTableContents
                    userList={this.state.partnerUsers}
                    callbacks={this.events}
                    joiningFlag={this.joiningFlag}
                  />
                </table>
                <InfinityScrollLoad
                  targetId='infinityscroll-target'
                  total={this.state.total}
                  isLoading={this.state.isLoading}
                  callback={this.getPartnerUsers}
                />
              </div>
            </div>
          </div>
        </div>
        <ConfirmIntegrateUserDialog
          visible={this.state.isShowPopupConfirmIntegrateUser}
          onCancel={() =>
            this.toggleDialog('isShowPopupConfirmIntegrateUser', false)
          }
          onConfirm={this.handleIntegrateUser}
          data={this.state.userIntegrates}
        />

        <ConfirmExistedEmailDialog
          visible={this.state.isShowPopupExistedEmail}
          userRoleCode={USER_ROLES.partner.id}
          onCancel={() => this.toggleDialog('isShowPopupExistedEmail', false)}
          isCreateNew={true}
          onConfirmNotIntegrate={this.invitePartner}
          onConfirmIntegrate={this.checkIntegrateUser}
        />

        <IntegrateError
          reason={this.state.messageIntegrate}
          visible={this.state.isShowPopupIntegrateUserError}
          onCancel={() =>
            this.toggleDialog('isShowPopupIntegrateUserError', false)
          }
        />

        <Information
          visible={this.state.isShowPopupInfo}
          title={this.state.popupInfoTitle}
          message={this.state.popupInfoMessage}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.toggleDialog('isShowPopupInfo', false)}
          multilineText={true}
        />

        <RegisteredCompaniesDialog
          visible={this.state.isShowRegisteredCompaniesDialog}
          registeredCompanies={this.state.registeredCompanies}
          companyName={this.state.company.name}
          companyAddress={
            (this.state.company.prefecture_name || '') +
            (this.state.company.city_name || '') +
            (this.state.company.street_number || '') +
            (this.state.company.building_name || '')
          }
          oneMasterTypeNameCompanyNumber={getOneMasterTypeNameCompanyNumber(
            this.state.company.one_master_flag,
            this.state.company.company_number
          )}
          onConfirm={this.onConfirmRegisteredCompaniesDialog}
          onCancel={this.onCancelRegisteredCompaniesDialog}
        />
      </div>
    );
  }
}

/**
 * 管理者招待 ダイアログ
 */
class InviteDialog extends React.Component {
  constructor(props) {
    super(props);
  }

  onSubmit = _.throttle(() => this.props.dialog.callback.submit(), 1000);

  render() {
    const readOnly = this.props.dialog.callback.data.readOnly;
    return (
      <div
        className='dialog dialog--wide dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog__header'>
          <span className='dialog__title'>協力会社管理者招待</span>
        </div>
        <div className='dialog__body'>
          <div className='dialog__row dialog__text'>
            {!readOnly && (
              <Description type='primary'>
                <React.Fragment>
                  {messageUtility.getMessage('I-000-155')}
                  <br />
                  {messageUtility.getMessage('I-000-157')}
                </React.Fragment>
              </Description>
            )}
            {readOnly && (
              <Description type='primary'>
                <React.Fragment>
                  {messageUtility.getMessage('I-000-156')}
                  <br />
                  {messageUtility.getMessage('I-000-157')}
                </React.Fragment>
              </Description>
            )}
          </div>
          <div className='InviteForm input--autofill-overwrite'>
            <FormList>
              <FormListItem label='会社名'>
                <FormElement>
                  <p>
                    {_.toString(this.props.dialog.callback.data.companyName)}
                  </p>
                </FormElement>
              </FormListItem>
              <FormListItem label='住所'>
                <FormElement>
                  <p>
                    {_.toString(this.props.dialog.callback.data.companyAddress)}
                  </p>
                </FormElement>
              </FormListItem>
              <FormListItem label='姓' required={!readOnly}>
                <FormElement
                  validate={this.props.dialog.callback.data.errors.name_sei}
                >
                  <input
                    type='text'
                    name='name_sei'
                    placeholder='（例）山田'
                    value={this.props.dialog.callback.data.name_sei}
                    onChange={e => this.props.dialog.callback.set(e)}
                    onBlur={e => this.props.dialog.callback.check(e)}
                    disabled={readOnly}
                  />
                </FormElement>
              </FormListItem>
              <FormListItem label='名' required={!readOnly}>
                <FormElement
                  validate={this.props.dialog.callback.data.errors.name_mei}
                >
                  <input
                    type='text'
                    name='name_mei'
                    placeholder='（例）太郎'
                    value={this.props.dialog.callback.data.name_mei}
                    onChange={e => this.props.dialog.callback.set(e)}
                    onBlur={e => this.props.dialog.callback.check(e)}
                    disabled={readOnly}
                  />
                </FormElement>
              </FormListItem>
              <FormListItem label='せい' required={!readOnly}>
                <FormElement
                  validate={this.props.dialog.callback.data.errors.kana_sei}
                >
                  <input
                    type='text'
                    name='kana_sei'
                    placeholder='（例）やまだ'
                    value={this.props.dialog.callback.data.kana_sei}
                    onChange={e => this.props.dialog.callback.set(e)}
                    onBlur={e => this.props.dialog.callback.check(e)}
                    disabled={readOnly}
                  />
                </FormElement>
              </FormListItem>
              <FormListItem label='めい' required={!readOnly}>
                <FormElement
                  validate={this.props.dialog.callback.data.errors.kana_mei}
                >
                  <input
                    type='text'
                    name='kana_mei'
                    placeholder='（例）たろう'
                    value={this.props.dialog.callback.data.kana_mei}
                    onChange={e => this.props.dialog.callback.set(e)}
                    onBlur={e => this.props.dialog.callback.check(e)}
                    disabled={readOnly}
                  />
                </FormElement>
              </FormListItem>
              <FormListItem label='メールアドレス' required={!readOnly}>
                <FormElement
                  validate={this.props.dialog.callback.data.errors.email}
                >
                  <input
                    type='text'
                    name='email'
                    placeholder='メールアドレスを入力'
                    value={this.props.dialog.callback.data.email}
                    onChange={e => this.props.dialog.callback.set(e)}
                    onBlur={e => this.props.dialog.callback.check(e)}
                    className='form-list__input-large'
                    disabled={readOnly}
                  />
                </FormElement>
              </FormListItem>
            </FormList>
            {/* エラー時のメッセージ */}
            {this.props.dialog.callback.data.errors.submit && (
              <div className='dialog-form__validate'>
                <p className='validate-message show'>
                  {this.props.dialog.callback.data.errors.submit}
                </p>
              </div>
            )}
          </div>
        </div>
        <div className='dialog__footer dialog__footer--horizontal'>
          {!readOnly && (
            <React.Fragment>
              <button
                id='modal-close-copy'
                className='btn-fixedsize--sub'
                onClick={() => this.props.dialog.callback.close()}
              >
                {messageUtility.getMessage('I-000-017')}
              </button>
              <button
                id='modal-close-copy'
                className='btn-fixedsize'
                onClick={this.onSubmit}
              >
                管理者招待
              </button>
            </React.Fragment>
          )}
          {readOnly && (
            <React.Fragment>
              <button
                id='modal-close-copy'
                className='btn-fixedsize--sub'
                onClick={() => this.props.dialog.callback.cancel()}
              >
                {messageUtility.getMessage('I-000-147')}
              </button>
              <button
                id='modal-close-copy'
                className='btn-fixedsize--effective'
                onClick={() => this.props.dialog.callback.confirm()}
              >
                {messageUtility.getMessage('I-000-148')}
              </button>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PartnerUsers.jsx